import { Stack, TextField, MenuItem } from '@mui/material';

const meses = [
  'Enero','Febrero','Marzo','Abril','Mayo','Junio',
  'Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'
];

export default function FiltroPeriodo({ mes, setMes, anio, setAnio }) {
  const anios = [];
  for (let i = new Date().getFullYear(); i >= 2020; i--) {
    anios.push(i);
  }

  return (
    <Stack direction="row" spacing={2} sx={{ mb: 3 }}>
      <TextField
        select
        label="Mes"
        value={mes}
        onChange={e => setMes(Number(e.target.value))}
      >
        {meses.map((m, i) => (
          <MenuItem key={i} value={i}>{m}</MenuItem>
        ))}
      </TextField>

      <TextField
        select
        label="Año"
        value={anio}
        onChange={e => setAnio(Number(e.target.value))}
      >
        {anios.map(a => (
          <MenuItem key={a} value={a}>{a}</MenuItem>
        ))}
      </TextField>
    </Stack>
  );
}
